import { createAction, props } from '@ngrx/store';

export const trackMixpanelEvent = createAction(
  '[App Page] Track Mixpanel Event',
  props<{ id: string; action: any }>(),
);
